import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewSingleEnquiry = (id) => {
  return useQuery({
    queryKey: ["enquiry", id],
    queryFn: async () => {
      const res = await api.get(`/enquiry/${id}`);
      return res.data;
    },
    enabled: !!id,
  });
};